{
  "selectPlaceholder": "Select an item",
  "tableResizer": "Resizer",
  "dropzoneLabel": "DropZone",
  "colorSwatchPicker": "Color swatches"
}
